import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CurrencySelectors } from '@recruitee/currency-data';
import type { SelectGroupedOptions } from '@recruitee/user-interface';

import type { DynamicSelectOptionsProvider } from '../dynamic-select-field.types';

@Injectable({
  providedIn: 'root',
})
export class CurrencySelectOptionsFacade implements DynamicSelectOptionsProvider {
  public selectGroupedOptions$: Observable<SelectGroupedOptions[]>;

  constructor(private store: Store) {
    this.selectGroupedOptions$ = this.store.select(CurrencySelectors.entities()).pipe(
      filter(list => !!list.length),
      map(currencies =>
        currencies.map(item => ({
          value: item.code,
          label: `${item.name} (${item.code})`,
        })),
      ),
      map(options => [
        {
          title: null,
          options,
        },
      ]),
    );
  }
}
